import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { steps } from 'dibs-buyer-layout/src/authModal/postAuth/constants';

export function showUserSurvey() {
    return authModalLoader.showPostAuth({
        props: { updateUserSurvey: true },
        step: steps.USER_SURVEY,
    });
}

// Check survey query param only once so it's not being auto launched during signup process.
let WAS_SURVEY_PARAM_CHECKED = false;

export function shouldLaunchUserSurvey() {
    if (!WAS_SURVEY_PARAM_CHECKED && typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const surveyParam = urlParams.get('shopping-preference-survey') || '';

        WAS_SURVEY_PARAM_CHECKED = true;

        return surveyParam.toLowerCase() === 'true';
    }

    return false;
}
